module.exports = __webpack_public_path__ + "static/img/11.2f75290.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/19/sp/11.png
// module id = SMPU
// module chunks = 0